import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import Cognito from '../utils/Cognito';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../AuthLayout';
import Syndicate from '../utils/Syndicate';
import { appRoutes } from '../../../path';
import { useBroadcastChannel } from '../../../utils/hooks';
import TosMessage from './forms/TosMessage';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { pageViewed } from '../../../utils/analytics/events/page/events';
import { AuthSubmitButton } from './LoginPagesUI';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

const SsoLogin = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = () => {
    setIsLoading(true);
    Cognito.samlLogin();
  };

  // message handler must be stable reference, otherwise it causes effect
  // in useBroadcastChannel on every rerender
  const loginMessageHandler = useCallback(() => {
    navigate('/');
  }, [navigate]);

  useBroadcastChannel({
    channelName: 'login',
    messageHandler: loginMessageHandler,
  });

  // redirect user to username login page if sso is not enabled
  // all qa and customers will be able to use non-sso login only
  useEffect(() => {
    const { enableSso } = Syndicate.getData();
    if (!enableSso) {
      navigate(appRoutes.login);
    }
  }, [navigate]);

  // if token is still valid, it means user manually enter the /login url
  // redirect user to the homepage.
  useEffect(() => {
    setIsLoading(true);
    Cognito.refreshToken()
      .then(() => {
        navigate('/');
      })
      .finally(() => setIsLoading(false));
  }, [navigate]);

  const { track } = useAnalytics();
  useEffect(() => {
    track(pageViewed({ category: 'login', name: 'sso login', id: null }));
  }, [track]);

  return (
    <AuthLayout heading={'Welcome'}>
      <Container>
        <AuthSubmitButton
          loading={isLoading}
          type="button"
          onClick={handleLogin}
          trackContext="login"
          trackAction="sso - log in"
        >
          Login
        </AuthSubmitButton>
        <TosMessage />
      </Container>
    </AuthLayout>
  );
};

export default SsoLogin;
